import React from 'react'
import { InfoOutlined } from '@mui/icons-material'
import { Box, SxProps, Theme, Typography } from '@mui/material'

import { lightTheme } from '~createTheme'

interface TextInfoProps {
  message: string
  backgroundColor?: string
  textColor?: string
  iconColor?: string
  maxWidth?: string | number
  sx?: SxProps<Theme>
}

const TextInfo: React.FC<TextInfoProps> = ({
  message,
  backgroundColor = 'var(--lightoffwhite)',
  textColor = lightTheme.palette.text.primary,
  iconColor = lightTheme.palette.primary.main,
  maxWidth = '600px',
  sx,
}) => {
  return (
    <Box
      sx={{
        backgroundColor,
        borderRadius: 2,
        padding: 1,
        marginY: 2,
        display: 'flex',
        alignItems: 'flex-start',
        maxWidth,
        width: '100%',
        ...sx,
      }}
    >
      <InfoOutlined
        sx={{
          color: iconColor,
          marginRight: 1,
          marginTop: 0.5,
          flexShrink: 0,
        }}
      />
      <Typography variant='body2' color={textColor}>
        {message}
      </Typography>
    </Box>
  )
}

export default TextInfo
